(function () {
  'use strict';

  var overlay, imgEl, counterEl, prevBtn, nextBtn;
  var images = [];
  var current = 0;

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'asetos-lightbox';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Image viewer');
    overlay.hidden = true;
    overlay.innerHTML =
      '<button type="button" class="asetos-lightbox-close" aria-label="Close">×</button>' +
      '<button type="button" class="asetos-lightbox-nav asetos-lightbox-prev" aria-label="Previous image">‹</button>' +
      '<img class="asetos-lightbox-img" alt="">' +
      '<button type="button" class="asetos-lightbox-nav asetos-lightbox-next" aria-label="Next image">›</button>' +
      '<div class="asetos-lightbox-counter" aria-hidden="true"></div>';
    document.body.appendChild(overlay);

    imgEl = overlay.querySelector('.asetos-lightbox-img');
    counterEl = overlay.querySelector('.asetos-lightbox-counter');
    prevBtn = overlay.querySelector('.asetos-lightbox-prev');
    nextBtn = overlay.querySelector('.asetos-lightbox-next');

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target.classList.contains('asetos-lightbox-close')) close();
    });
    prevBtn.addEventListener('click', function (e) { e.stopPropagation(); step(-1); });
    nextBtn.addEventListener('click', function (e) { e.stopPropagation(); step(1); });
    document.addEventListener('keydown', function (e) {
      if (overlay.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') step(-1);
      else if (e.key === 'ArrowRight') step(1);
    });
  }

  function render() {
    var item = images[current];
    imgEl.src = item.src;
    imgEl.alt = item.alt || '';
    var single = images.length < 2;
    overlay.classList.toggle('is-single', single);
    counterEl.textContent = single ? '' : (current + 1) + ' / ' + images.length;
  }

  function step(dir) {
    if (images.length < 2) return;
    current = (current + dir + images.length) % images.length;
    render();
  }

  function open(list, index) {
    if (!overlay) build();
    images = list;
    current = index || 0;
    render();
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () { overlay.classList.add('is-open'); });
  }

  function close() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { overlay.hidden = true; }, 250);
  }

  function fullSrc(el) {
    var attr = el.getAttribute('data-zoom-src');
    if (attr) return attr;
    var src = el.currentSrc || el.src;
    return src.replace(/([?&]width=)\d+/, '$11600');
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest('.asetos-zoomable');
    if (!el) return;
    // Don't hijack images that are links to another page.
    if (el.closest('a')) return;
    e.preventDefault();

    var list = null;
    var idx = 0;
    var listAttr = el.getAttribute('data-zoom-list');
    if (listAttr) {
      try {
        var urls = JSON.parse(listAttr);
        if (urls.length) {
          list = urls.map(function (u) { return { src: u, alt: el.alt }; });
          var cur = el.getAttribute('data-zoom-src') || fullSrc(el);
          var found = urls.indexOf(cur);
          idx = found > -1 ? found : 0;
        }
      } catch (err) { list = null; }
    }
    if (!list) list = [{ src: fullSrc(el), alt: el.alt }];
    open(list, idx);
  });
})();
